import { render, staticRenderFns } from "./LoyaltySubscriptionTypeAddComponent.vue?vue&type=template&id=b28ab800&scoped=true"
import script from "./LoyaltySubscriptionTypeAddComponent.vue?vue&type=script&lang=ts"
export * from "./LoyaltySubscriptionTypeAddComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b28ab800",
  null
  
)

export default component.exports